<template>
<div class="contentBox balancePage">
    <div class="pageTitle">
        <h1>余额</h1>
    </div>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span class="headerTitle">账户余额</span>
            <button v-if="!!sponsor.showRecharge" style="float: right" @click="jumpPage('/finance/my-order')">查看账单</button>
        </div>
        <div class="balance">
            <div class="item">
                <span class="title">流量</span>
                <div :class="flowClass">{{balance.formatFlow}}<span>{{balance.formatFlowUnit}}</span></div>
            </div>
            <div class="item">
                <span class="title">空间</span>
                <div :class="spaceClass">{{balance.formatSpace}}<span>{{balance.formatSpaceUnit}}</span></div>
            </div>
            <div class="item last">
                <span class="title">时长</span>
                <div :class="durationClass">{{balance.formatDuration}}</div>
            </div>
        </div>
    </el-card>
    <button v-if="!!sponsor.showRecharge" class="purchaseHistory" @click="jumpPage('/finance/recharge')">
        <img src="../../../assets/currency.svg" alt /> 购买充值
    </button>
    <div class="balanceListWrap">
        <el-table :data="packages" style="width: 100%" header-row-class-name="tableHeader noBorderHeader">
            <el-table-column prop="title" label="套餐"></el-table-column>
            <el-table-column label="流量" align="right" width="160">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.flowUsed"></i>{{scope.row.formatFlow}}
                </template>
            </el-table-column>
            <el-table-column label="空间" align="right" width="160">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.spaceUsed"></i>{{scope.row.formatSpace}}
                </template>
            </el-table-column>
            <el-table-column label="时间" align="right" width="160">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.durationUsed"></i>{{scope.row.formatDuration}}
                </template>
            </el-table-column>
            <el-table-column prop="validTime" label="激活/到期时间" align="right" width="260"></el-table-column>
            <el-table-column label="状态" align="center" width="100">
                <template slot-scope="props">
                    <div v-if="props.row.active === 1" class="statusIcon">
                        <img src="../../../assets/stateRight.svg" alt="" title="生效中">
                    </div>
                    <div v-if="props.row.active === 0" class="statusIcon">
                        <img src="../../../assets/stateError.svg" alt="" title="未激活">
                    </div>
                    <div v-if="props.row.active < 0" class="statusIcon">
                        <img src="../../../assets/stateDisAct.svg" alt="" title="已过期">
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
                <template slot-scope="props">
                    <div v-if="props.row.active === 0" class="activationBtn" @click="activePackage(props.row)">激活</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="paginationBox purchaseHistoryPagination" v-if="pageCount > 1">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="currentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
    <div class="useRules">
        <div class="title">
            <img src="../../../assets/rulesTips.svg" alt />套餐使用规则
        </div>
        <ol>
            <li>1. 套餐中的流量和时长，有效套餐之间可叠加，存储空间取有效套餐中的最大值；</li>
            <li>2. 流量和时长抵扣时，优先抵扣无限套餐；</li>
            <li>3. 定量套餐优先抵扣最先过期的套餐；</li>
            <li>4. 符合目前扣除规则的套餐，对应项前会有<i class="el-icon-check"></i>标记。</li>
        </ol>
    </div>
</div>
</template>

<script>
    import common from '../../../common.vue';
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    const ACTIVE_CODE_MAPPER = {
        "-1": "登录已过期",
        "0": "激活成功",
        "1": "无效套餐",
        "2": "该套餐已经被激活"
    };

    export default {
        name: "Balance",
        data() {
            return {
                pageIndex: 1,
                pageSize: 10,
                pageCount: 0,
                packages: [],
                balance: {},
                sponsor: {showRecharge: false},
                flowClass: 'number',
                spaceClass: 'number',
                durationClass: 'number'
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            handleSizeChange(val) {
                this.pageSize = val;
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.getPackages(val);
            },
            /**
             * 根据缓存用户数据调整界面
             */
            getCache(){
                let s = localStorage.getItem('sponsor');
                if(s){
                    this.sponsor = JSON.parse(s);
                }
            },
            /**
             * 获取余额概况
             */
            getTotal() {
                let _this = this;
                _this.$axios.post(common._BASE_ + '/balance/balanceTotal').then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data){
                        _this.formatTotal(r.data);
                        _this.getPackages(1);
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 格式化余额信息
             * @param balance 余额数据
             */
            formatTotal(balance){
                console.info(balance);

                this.balance = balance || {};
                // 流量
                if(balance.flow === -1){
                    this.balance.formatFlow = '无限';
                    this.balance.formatFlowUnit = '';
                }else{
                    let f = common.formatSize(balance.flowOwe > 0? balance.flowOwe: balance.flow);
                    this.balance.formatFlow = f[0];
                    this.balance.formatFlowUnit = f[1];
                    this.flowClass = balance.flowOwe > 0? 'number owe': 'number';
                }
                // 空间
                if(balance.totalSpace === -1){
                    this.balance.formatSpace = '无限';
                    this.balance.formatSpaceUnit = '';
                }else{
                    let s = balance.totalSpace - balance.space, fs = common.formatSize(s);
                    this.balance.formatSpace = fs[0];
                    this.balance.formatSpaceUnit = fs[1];
                    this.spaceClass = s < 0? 'number owe': 'number';
                }
                // 时长
                if (balance.duration === -1) {
                    this.balance.formatDuration = '无限';
                } else{
                    this.balance.formatDuration = common.seconds2duration(balance.durationOwe > 0 ? balance.durationOwe : balance.duration);
                    this.durationClass = balance.durationOwe > 0? 'number owe': 'number';
                }
            },
            /**
             * 获取套餐列表
             * @param pageIndex
             */
            getPackages(pageIndex){
                let _this = this, index = pageIndex || 1;
                if(index === 1){ _this.packages = []; }

                _this.pageIndex = index;
                _this.$axios.post(common._BASE_ + '/balance/packageList',
                    this.$qs.stringify({pageNo: index, pageSize: _this.pageSize})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data){
                        _this.formatPackages(r.data);
                        _this.pageCount = Math.ceil(r.count / _this.pageSize);
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 格式化套餐
             * @param data
             */
            formatPackages(data){
                console.info(data);
                let _this = this;

                _this.packages = [];
                (data || []).forEach(function (item) {
                    // 流量
                    item.formatFlow = item.flowTotal === -1? '无限': common.formatSize(item.flowBalance).join(' ');
                    item.flowUsed = (item.flowUsed === 1);
                    // 空间
                    item.formatSpace = item.spaceTotal === -1? '无限' : common.formatSize(item.spaceBalance).join(' ');
                    item.spaceUsed = (item.spaceUsed === 1);
                    // 时长
                    item.formatDuration = (item.durationTotal === -1)? '无限': (item.durationBalance / 3600).toFixed(1);
                    item.durationUsed = (item.durationUsed === 1);
                    // 时间
                    item.validTime = item.activeTime? moment(item.activeTime).format('YYYY-MM-DD'): '-';
                    item.validTime += ('/' + (item.expireTime? moment(item.expireTime).format('YYYY-MM-DD'): '-'));

                    _this.packages.push(item);
                });
            },

            /**
             * 激活套餐
             * @param pack 套餐
             */
            activePackage(pack){
                let _this = this;

                _this.$axios.post(common._BASE_ + '/balance/active',
                    this.$qs.stringify({balanceId: pack.balanceId})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0){
                        pack.status = 1;
                        _this.$notify.success({
                            title: '成功',
                            message: '套餐激活成功'
                        });
                        // 刷新余额
                        _this.getTotal();
                    }else{
                        _this.$notify.error({
                            title: '失败',
                            message: ACTIVE_CODE_MAPPER["" + r.code]
                        });
                    }
                });
            }
        },

        mounted() {
            this.getCache();
            this.getTotal();
        },
    };
</script> 

<style lang="less">
.balancePage {
    .balance {
        display: flex;

        .item {
            margin-right: 299px;
        }

        .last {
            margin-right: 0;
        }

        .title {
            font-size: 14px;
            font-weight: 400;
            color: #7e868c;
        }

        .number {
            font-size: 34px;
            font-weight: bold;
            color: #221816;
            margin-top: 6px;

            span {
                font-size: 14px;
                font-weight: 400;
                color: #221816;
                margin-left: 15px;
            }
        }

        .owe{
            color: #F56C6C;
        }
        .owe:before{
            content: '透支';
            font-size: 12px;
            margin-right: 8px;
        }
    }

    .purchaseHistory {
        width: 137px;
        height: 40px;
        background: #076eff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 17px;
        margin-bottom: 18px;

        img {
            margin-right: 6px;
        }
    }

    .purchaseHistory:hover {
        background: #4aa3f8;
    }

    .balanceListWrap i{
        margin-right: 8px;
        color: #67C23A;
    }

    .statusIcon {
        width: 25px;
        height: 25px;
        margin: 0 auto;
    }

    .statusIcon img {
        width: 25px;
        height: 25px;
        display: block;
    }

    .activationBtn {
        width: 80px;
        height: 26px;
        background: #FFFFFF;
        border: 1px solid #C1C5C5;
        line-height: 26px;
        border-radius: 4px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        color: #221816;
        margin: 0 auto;
        cursor: pointer;
    }

    .activationBtn:hover {
        background: #306ff6;
        color: #fff;
        border: none;
    }

    .purchaseHistoryPagination {
        text-align: left;
    }

    .useRules {
        font-size: 12px;
        line-height: 26px;
        color: #55565f;
        margin-top: 22px;

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #221816;
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            img {
                margin-right: 8px;
            }
        }
    }

}

.el-card__header {
    padding: 0;
    width: 100%;

    .headerTitle {
        font-size: 16px;
        font-weight: bold;
        color: #221816;
    }

    .clearfix {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 51px;
        padding: 0 29px;
        font-size: 16px;
        font-weight: bold;
        color: #221816;
    }

    button {
        width: 80px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #c1c5c5;
        border-radius: 4px;
    }

    button:hover {
        background: #306ff6;
        color: #fff;
        border: none;
    }
}

.el-table__body-wrapper.is-scrolling-none,
.el-table__header {
    border: solid 1px #ebeef5;
}

.el-table__header {
    border-bottom: none;
}

.el-table__body-wrapper.is-scrolling-none {
    border-top: none;
}

.el-table th.el-table__cell>.cell {
    padding-left: 30px;
}

.el-table .is-center .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
</style>